import { create } from "zustand";

export type ReservationTabKey =
    | "ALL"
    | "ADULT"
    | "CHILD_LESS_THEN_EIGHT"
    | "CHILD_ABOVE_EIGHT"
    | "CHILD_TWELVE_TO_SIXTEEN"
    | "COURT"
    | "MEMBERSHIP";

type ReservationsUiStore = {
    tab: ReservationTabKey;
    setTab: (tab: ReservationTabKey) => void;
};

export const useReservationsUiStore = create<ReservationsUiStore>((set) => ({
    tab: "ALL",
    setTab: (tab) => set({ tab }),
}));
